module.exports = __webpack_public_path__ + "static/media/ic_back_2.32f74e4b.svg";